<script>
import { commands } from '../../js/lib/functions.js'
import { navigate } from '@trullock/page-manager'
import { hideLoading, showLoading } from '../../js/utils/loading.js';
import { showToast } from '../../js/utils/toast.js';
import { listenToCurrentUserView } from '../../js/readModel.js';

export const pageName = 'account-insurance';
export const pageRoute = '/account/insurance';
export const title = 'Insurance';

export default {
	data() {
		return { 
			user: null,
			BMFANumber: '',
			BMFASurname: '',

			ready: false,
			isDirty: false
		}
	},
	methods: {
		beforeHide() {
			return this.isDirty ? 'Are you sure you want to abandon your changes?' : null
		},
		async boot(opts) {
			await listenToCurrentUserView(user => this.user = user);
		},
		async show()
		{
			commands.warmUp();

			this.BMFANumber = this.user.insurance.BMFANumber;
			this.BMFASurname = this.user.insurance.BMFASurname;
			
			this.ready = true;
			this.isDirty = false;
		},
		changed() {
			this.isDirty = true;
		},
		async submit() {
			
			showLoading();

			this.$refs.bmfaNumber.setCustomValidity('');
			this.$refs.bmfaSurname.setCustomValidity('');
			
			let result = await commands.users.account.changeInsurance({
				number: this.BMFANumber.toString(),
				surname: this.BMFASurname
			});
			
			hideLoading();

			if(!result.success)
			{
				if(result.result == 'expired')
				{
					this.$refs.bmfaSurname.setCustomValidity(' ');
					this.$refs.bmfaSurname.reportValidity();

					this.$refs.bmfaNumber.setCustomValidity('Insurance is not active. If you believe this to be in error please first check on your BMFA account and then contact membership@ukra.org.uk');
					this.$refs.bmfaNumber.reportValidity();

					return;
				}
				else if(result.result == 'not-found')
				{
					this.$refs.bmfaSurname.setCustomValidity(' ');
					this.$refs.bmfaSurname.reportValidity();

					this.$refs.bmfaNumber.setCustomValidity('Insurance details not found. If you believe this to be in error please first check on your BMFA account and then contact membership@ukra.org.uk');
					this.$refs.bmfaNumber.reportValidity();

					return;
				}
				else
				{
					this.$refs.bmfaSurname.setCustomValidity(' ');
					this.$refs.bmfaSurname.reportValidity();

					this.$refs.bmfaNumber.setCustomValidity('An error occurred validating your insurance details. Please contact membership@ukra.org.uk');
					this.$refs.bmfaNumber.reportValidity();

					return;
				}
			}

			this.isDirty = false;

			navigate('/')

			showToast({
				message: 'Insurance details updated',
				style: 'bg-success'
			})
		}
	}
}
</script>
<template>
<div class="container" v-if="ready">
    <form @submit.prevent="submit" @change="changed">
		<div class="row justify-content-center">
			<div class="col-12 col-md-6 my-5">
				<h1 class="display-4 text-center mb-3">Insurance</h1>
				<p class="text-muted text-center mb-5">You must have insurance to fly rockets.</p>
				<fieldset class="mb-4">
					<div class="row">
						<div class="col">
							<div class="form-group mb-0">
								<label>BMFA Number</label>
								<input type="text" class="form-control" ref="bmfaNumber" pattern="[0-9]+" v-model="BMFANumber" required placeholder="e.g. 123456" />
								<span class="invalid-feedback"></span>
							</div>
						</div>
						<div class="col">
							<div class="form-group mb-0">
								<label>Surname</label>
								<input type="text" class="form-control" ref="bmfaSurname" v-model="BMFASurname" required placeholder="e.g. Smith" />
								<span class="invalid-feedback"></span>
							</div>
						</div>
					</div>
					<span class="form-text text-muted small">Provide your number and surname from your BMFA insurance. See <a href="https://bmfa.org/join-us" target="_blank">https://bmfa.org/join-us</a> for more information.</span>
				</fieldset>

				<button type="submit" class="btn btn-lg btn-primary btn-block">Save changes <span class="fe fe-check-circle"></span></button>
			</div>
		</div>
	</form>
</div>
</template>